var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h5',[_c('a',{attrs:{"href":"https://twitter.com/itbuilders"}},[_vm._v(" Twitter : @itbuilders")])])])}]

export { render, staticRenderFns }